
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.056 20.306A.533.533 0 019.3 20.3a.527.527 0 010-.75l4.548-4.548-4.546-4.546a.533.533 0 11.756-.756l4.545 4.546L19.152 9.7a.533.533 0 11.755.755l-4.548 4.547 4.546 4.546a.533.533 0 11-.755.755l-4.546-4.545-4.548 4.548z","fill":"#4B62C1"}})])
          )
        }
      }
    